import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <img 
              src="https://static.readdy.ai/image/de296e9d59e1469590f5774831dff4f2/bf7a4ae464802c3f1a3a404352231c8b.png" 
              alt="우진에코텍" 
              className="h-14 w-auto object-contain mb-4"
            />
            <p className="text-sm text-gray-300 leading-relaxed">
              용접철망류 및 매트리스개비온 전문 제조기업<br />
              하천정비 및 침식방지 구조물 분야의<br />
              안정적인 솔루션 제공
            </p>
          </div>
          
          <div>
            <h3 className="text-base font-semibold mb-4">빠른 링크</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">회사소개</Link></li>
              <li><Link to="/products" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">제품소개</Link></li>
              <li><Link to="/technology" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">기술력</Link></li>
              <li><Link to="/projects" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">시공사례</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">문의하기</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-base font-semibold mb-4">연락처</h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-teal-400 mt-1 mr-2"></i>
                <span>강원도 홍천군 화촌면 송정2길9</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line text-teal-400 mr-2"></i>
                <span>033-435-2696</span>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line text-teal-400 mr-2"></i>
                <span>seok8131@naver.com</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-400">
          <p>&copy; 2024 우진에코텍주식회사. All rights reserved.</p>
          <p className="mt-2">
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
